import { Middleware } from "../Middleware";
import { MiddlewareInterface } from "../MiddlewareInterface";

class MailsWillMount extends Middleware implements MiddlewareInterface {

  public component: any;

  constructor() {
    super();
  }

  public process(): void {
    let emailAccounts = this.component.props.app.emailAccounts.filter(emailAccount => {
      return emailAccount.removed === false;
    });

    emailAccounts = emailAccounts
    .filter((emailAccount) => {
      return emailAccount.isAgencyAccount();
    });

    const defaultMailAccount = sessionStorage.getItem('value-email-account') ? +sessionStorage.getItem('value-email-account') : emailAccounts[0] ? emailAccounts[0].id : null;

    this.component.setState({
      isPromptOpen: false,
      entity: null,
      defaultEmailAccountId: defaultMailAccount ? defaultMailAccount : null,
      valueFilter: defaultMailAccount && defaultMailAccount,
    });
  }
}

export default new MailsWillMount();
